import { FC, ReactNode } from 'react';
import styles from './PunchupSplitRow.module.css';

export interface PunchupSplitRowProps {
	/** Content anchored to the left. Grows to fill available space. */
	left?: ReactNode;
	/** Content anchored to the right edge. Right-justifies its children. */
	right?: ReactNode;
	/** Vertical alignment between the two columns. Default: 'start'. */
	align?: 'start' | 'center';
	/** When true, stacks columns vertically on narrow viewports (≤600px). */
	stackOnNarrow?: boolean;
	/** When true, the right column appears first (top) when stacked on narrow viewports. */
	reverseOnNarrow?: boolean;
}

/**
 * Two-column flex layout: left content grows to fill space, right content
 * is pushed to the right edge with items right-justified. The row wraps — a right column
 * that cannot share the line drops below the left one rather than overflowing the page.
 *
 * Used by the Punchup show dashboard header (align="start", stackOnNarrow):
 * the stacked title block left, the show action buttons right.
 */
export const PunchupSplitRow: FC<PunchupSplitRowProps> = ({
	left,
	right,
	align = 'start',
	stackOnNarrow = false,
	reverseOnNarrow = false,
}) => {
	const classNames = [
		styles.splitRow,
		align === 'center' ? styles.splitRowCenter : null,
		stackOnNarrow ? styles.splitRowStack : null,
		reverseOnNarrow ? styles.splitRowReverse : null,
	]
		.filter(Boolean)
		.join(' ');

	return (
		<div className={classNames}>
			{left != null && <div className={styles.left}>{left}</div>}
			{right != null && <div className={styles.right}>{right}</div>}
		</div>
	);
};
